var defaultDeliveryType = "PICKUP";
/**
 * Hook to get the handover type.
 * It is either loaded from the sector or it defaults to `PICKUP`.
 */

export var getHandoverType = function getHandoverType(_ref) {
  var sector = _ref.sector;
  var hasDeliveryType = sector && sector.deliveryType;
  return hasDeliveryType ? sector.deliveryType["enum"] : defaultDeliveryType;
};